module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAQCAYAAAAiYZ4HAAAAdUlEQVQ4T2M0zHznycD4by4DA4MkA37wnOE/UzKjYdabZ0Qohhn1HKThP4h3fpoIIz4LYOpGNQz1UCKQjuDS8JhG1vCficmG+R8D4z+Gf4fRDcKa+EAaQAoZ//07gqbhBaNB9isvxv9MoOQtQcBZT/8z/ksDACY+YtSqtC+mAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-username.png
// module id = 176
// module chunks = 0